import React from "react";

const FilterChips = ({ options, activeId, label = "Filter", onSelect }) => (
  <div className="fin-chips" role="radiogroup" aria-label={label}>
    {options.map((option) => (
      <button
        key={option.id}
        type="button"
        role="radio"
        aria-checked={option.id === activeId}
        className={`fin-chip${option.id === activeId ? " is-active" : ""}`}
        onClick={() => onSelect(option.id)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default FilterChips;
